import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJudgeGavel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconJudgeGavel"><Path d="M15.5 20.5H16.5M15.5 20.5L14 17.5H5L3.5 20.5M15.5 20.5H3.5M2.5 20.5H3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.9034 9.40341L12.375 12.9318L9.5 10.0568L16.5568 3L19.4318 5.875L15.9034 9.40341ZM15.9034 9.40341L21 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M1.5 13.5H4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 10.5L3 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconJudgeGavel;
